import cx from 'classnames'
import { ComponentType, useEffect, useState } from 'react'
import { isOpenFinRuntime } from '../containers/OpenFin/helpers'
import { getAuthToken } from '../store/auth/selectors'
import { fetchResubmitOrders, fetchUserOrders } from '../store/order/actions'
import { handleWindowSettings } from '../store/settings/actions'
import { useAppDispatch, useAppSelector } from '../store/types'
import {
  adjustServerTimeDelay,
  connect,
  logServerMetadata
} from '../store/ws/actions'
import { hasError, isConnected, isPending } from '../store/ws/selectors'

import styles from '../assets/scss/global.module.scss'

export const needsWSConnection =
  <Props extends object>(Component: ComponentType<Props>) =>
  (props: Props) => {
    const dispatch = useAppDispatch()
    const authToken = useAppSelector(getAuthToken)
    const connected = useAppSelector(isConnected)
    const pending = useAppSelector(isPending)
    const error = useAppSelector(hasError)
    const [initialized, setInitialized] = useState(connected)

    useEffect(() => {
      if (authToken && !pending && !connected && !error) {
        dispatch(connect())
      }
    }, [authToken, pending, connected, error])

    useEffect(() => {
      if (connected && !initialized) {
        setInitialized(true)
        dispatch(handleWindowSettings())
        dispatch(logServerMetadata())
        dispatch(adjustServerTimeDelay())
        dispatch(fetchUserOrders())
        dispatch(fetchResubmitOrders())
      }
    }, [connected, initialized])

    return (
      <div
        className={cx(styles.columnWrapper, {
          [styles.isFin]: isOpenFinRuntime()
        })}
      >
        <Component {...props} />
      </div>
    )
  }
